<template>
  <v-list-item
    v-if="!link.is_dropdown"
    :href="link.url"
    link
    :class="_activeClass"
  >
    <v-list-item-icon>
      <v-icon
        :class="{
          'ml-5': subMenu
        }"
      >
        {{ link.icon }}
      </v-icon>
    </v-list-item-icon>
    <v-list-item-title>
      {{ link.name }}
    </v-list-item-title>
  </v-list-item>

  <v-list-group
    v-else
    active-class="primary--text"
    :value="_isOpen(link.sub_menus)"
  >
    <template #activator>
      <v-list-item-icon>
        <v-icon>{{ link.icon }}</v-icon>
      </v-list-item-icon>
      <v-list-item-title>
        {{ link.name }}
      </v-list-item-title>
    </template>

    <LinkItem
      v-for="subMenu in link.sub_menus"
      :key="subMenu.id"
      :link="subMenu"
      :active-url="activeUrl"
      sub-menu
    />
  </v-list-group>
</template>

<script>
export default {
  name: "LinkItem",
  props: {
    link: {
      type: Object,
      required: true
    },
    activeUrl: {
      type: String,
      required: true
    },
    subMenu: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    _isOpen() {
      return list => {
        return list.some(item => item.url == `/${this.activeUrl}`);
      };
    },
    _activeClass() {
      return this.link.url === `/${this.activeUrl}` ||
        this.link.url === this.activeUrl
        ? "primary--text v-list-item--active"
        : "";
    }
  }
};
</script>

<style></style>
